// extracted by mini-css-extract-plugin
module.exports = {"cp-guid":"Guidance_cp-guid__1p1X4","box":"Guidance_box__2GSMZ","img":"Guidance_img__2Eec9","btn":"Guidance_btn__3MmIX"};